module.exports = __webpack_public_path__ + "img/16x9.7db4c2b4.svg";